<template>
	<div :style="{direction: $vs.rtl ? 'rtl' : 'ltr'}">
		<feather-icon
			icon="EditIcon"
			svgClasses="h-5 w-5 mr-2 hover:text-primary cursor-pointer"
			:title="$t('Edit')"
			@click="editRecord"
		/>
		<feather-icon
			icon="FileTextIcon"
			svgClasses="h-5 w-5 mr-2 hover:text-warning cursor-pointer"
			:title="$t('SeeDetailedInformation')"
			@click="seeDetailInformation"
		/>
		<feather-icon
			v-if="frequencyDeletePermission"
			icon="Trash2Icon"
			svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
			:title="$t('Crud.Delete')"
			@click="confirmDeleteRecord"
		/>
	</div>
</template>

<script>
export default {
	name: "CellRendererActions",
	computed: {
		frequencyDeletePermission() {
			return this.$store.getters.checkPermission("FREQUENCY_D");
		},
	},
	methods: {
		editRecord() {
			this.$router.push("/apps/frequency/frequency-edit/" + this.params.data.id).catch(() => {});
		},
		seeDetailInformation() {
			this.$router.push("/apps/frequency/frequency-view/" + this.params.data.id).catch(() => {});
		},
		confirmDeleteRecord() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text:
					this.$t("Frequency.DeleteFrequency.Text1") +
					` "${this.params.data.name}"? ` +
					this.$t("Frequency.DeleteFrequency.Text2"),
				accept: this.deleteRecord,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteRecord() {
			this.$store
				.dispatch("frequency/deleteById", this.params.data.id)
				.then((res) => {
					this.showDeleteSuccess();
				})
				.catch((err) => {
					if (err.response.status === 404) {
						return;
					}
					console.error(err);
				});
		},
		showDeleteSuccess() {
			this.$vs.notify({
				color: "success",
				title: this.$t("Frequency.CellRenderer.DeleteSuccess.Title"),
				text: this.$t("Frequency.CellRenderer.DeleteSuccess.Text"),
			});
		},
	},
};
</script>
